import { useMediaQuery } from '@react-hook/media-query';

export function useIsMobile() {
  return !useMediaQuery('(min-width: 768px)');
}

export default useIsMobile;
